/* eslint-disable @typescript-eslint/no-explicit-any */
import { Form, Offcanvas } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import FeatherIcon from 'feather-icons-react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

import Button from 'components/base/Button';
import { useWindowWidth } from 'utils/useWindowSize';
import CreateFilterInfo from './CreateFilterInfo';
import inventoryService from 'service/inventory';

interface InfoProps {
  setBarcodeValue?: any;
  barcodeValue?: any;
  infoValues?: any;
  savedValues?: any;
  setSavedValues?: any;
  setGetFilterData?: any;
  getFilterData?: any;
}

const InfoFilter = ({
  setBarcodeValue,
  barcodeValue,
  savedValues,
  setSavedValues,
  setGetFilterData,
  getFilterData
}: InfoProps) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const { t } = useTranslation();
  const windowSize: any = useWindowWidth();
  const url = process.env.REACT_APP_CDN_URL;

  const [dateFrom, setDateFrom] = useState<any>(null);
  const [dateTo, setDateTo] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  const updateSearchParams = (key: string, value: string) => {
    const newParams = new URLSearchParams(searchParams);
    if (value) {
      newParams.set(key, value); // Set new value
    } else {
      newParams.delete(key); // Remove if empty
    }
    setSearchParams(newParams);
  };

  const [openModal, setOpenModal] = useState(false);

  // const generateExcelFile = () => {
  //   const worksheetData = infoValues?.map((item: any, index: any) => ({
  //     '№': index + 1,
  //     '№ накладной': item?.inventory_number,
  //     'Материально-ответственного лицо': item?.inventory_name,
  //     'Дата накладной': item?.date_inventory,
  //     Склад: item?.inventory_warehouse,
  //     'Умный режим': item?.smart_mode,
  //     'Дата создания': item?.date_create_inventory
  //   }));

  //   const worksheet = XLSX.utils.json_to_sheet(worksheetData);
  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, 'Scales Data');

  //   XLSX.writeFile(workbook, 'инвентаризации.xlsx');
  // };

  const handleExport = () => {
    setLoading(true);
    const customFilename: string = 'Закуп по накладной.xlsx';

    // Prepare request payload
    const requestData = {
      ...getFilterData,
      barcode: barcodeValue
    };

    // Fetch report and trigger download
    inventoryService
      ?.getInventoryListExcel(requestData)
      .then((res: any) => {
        setLoading(false);
        if (res?.filename !== '') {
          const resUrl = `${url}${res?.filename}`;
          const link = document.createElement('a');
          link.href = resUrl;
          link.download = customFilename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      })
      .catch(error => {
        setLoading(false);
        console.log('error==>', error);
      });
  };

  useEffect(() => {
    const barcodeParam = searchParams.get('barcode');
    const inventoryNumberParam = searchParams.get('inventoryNumber');
    const stockParam = searchParams.get('stock') || '';
    const responsibleParam = searchParams.get('responsible') || '';
    const dateFromParam = searchParams.get('dateFrom');
    const dateToParam = searchParams.get('dateTo');

    if (dateFromParam) {
      const parsedDateFrom = parseInt(dateFromParam, 10);
      if (!isNaN(parsedDateFrom)) setDateFrom?.(parsedDateFrom);
    }
    if (dateToParam) {
      const parsedDateTo = parseInt(dateToParam, 10);
      if (!isNaN(parsedDateTo)) setDateTo?.(parsedDateTo);
    }

    setBarcodeValue(barcodeParam);
    setGetFilterData({
      date_from: dateFromParam,
      date_to: dateToParam,
      inventory_number: inventoryNumberParam,
      user_id: responsibleParam,
      warehouse_id: stockParam
    });
    setSavedValues([
      {
        date_from: dateFromParam,
        date_to: dateToParam,
        inventory_number: inventoryNumberParam,
        user_id: responsibleParam,
        warehouse_id: stockParam
      }
    ]);
  }, [searchParams]);

  return (
    <div>
      <Form noValidate>
        <div
          className={
            windowSize > 768 ? 'd-flex gap-3' : 'd-flex flex-column gap-3'
          }
        >
          <Form.Floating>
            <Form.Control
              value={barcodeValue}
              onChange={e => {
                setBarcodeValue(e.target.value);
                updateSearchParams('barcode', e.target.value);
              }}
              type="text"
              placeholder={t('enter_barcode')}
              onFocus={e => e.target.select()}
            />
            <label htmlFor="floatingInputCustom">{t('enter_barcode')}</label>
          </Form.Floating>

          <div className="d-flex gap-2">
            <Button
              className="d-flex align-items-center gap-2"
              style={{ height: '48px' }}
              variant="outline-primary"
              onClick={() => setOpenModal(true)}
            >
              <FeatherIcon icon="filter" size={20} />
              {t('filter')}
            </Button>
            <Button
              className="d-flex align-items-center gap-2"
              style={{ height: '48px' }}
              variant="outline-primary"
              onClick={() => handleExport()}
              loading={loading}
              loadingPosition="start"
            >
              <FeatherIcon icon="upload-cloud" size={20} />
              {t('export')}
            </Button>
          </div>
        </div>

        <Offcanvas
          show={openModal}
          onHide={() => {
            setOpenModal(false);
          }}
          placement="end"
          backdrop="static"
          keyboard={false}
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title style={{ fontSize: '24px', fontWeight: '600' }}>
              {t('filter')}
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <CreateFilterInfo
              savedValues={savedValues}
              setSavedValues={setSavedValues}
              setOpenModal={setOpenModal}
              setGetFilterData={setGetFilterData}
              dateFrom={dateFrom}
              dateTo={dateTo}
              setDateFrom={setDateFrom}
              setDateTo={setDateTo}
            />
          </Offcanvas.Body>
        </Offcanvas>
      </Form>
    </div>
  );
};

export default InfoFilter;
